/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SendCvToCompany } from '../../models/send-cv-to-company';

export interface SendCvToCompany$Params {
  studentId: string;
      body?: SendCvToCompany
}

export function sendCvToCompany(http: HttpClient, rootUrl: string, params: SendCvToCompany$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, sendCvToCompany.PATH, 'post');
  if (params) {
    rb.path('studentId', params.studentId, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

sendCvToCompany.PATH = '/studentprofile/{studentId}/publiccv/sendtocompany';
